var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload02SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4474 13.1058C21.9414 13.3528 22.1416 13.9535 21.8946 14.4474L19.4474 19.3419C18.9393 20.3582 17.9005 21.0002 16.7642 21.0002H7.23629C6.09997 21.0002 5.06118 20.3582 4.55301 19.3419L2.10579 14.4474C1.8588 13.9535 2.05903 13.3528 2.55301 13.1058C3.04698 12.8588 3.64766 13.059 3.89465 13.553L6.34186 18.4474C6.51125 18.7862 6.85751 19.0002 7.23629 19.0002H16.7642C17.1429 19.0002 17.4892 18.7862 17.6586 18.4474L20.1058 13.553C20.3528 13.059 20.9535 12.8588 21.4474 13.1058Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C12.5523 15 13 14.5523 13 14V7.5H14.5C14.9045 7.5 15.2691 7.25636 15.4239 6.88268C15.5787 6.50901 15.4931 6.07889 15.2071 5.79289L12.7071 3.29289C12.3166 2.90237 11.6834 2.90237 11.2929 3.29289L8.79292 5.79289C8.50692 6.07889 8.42137 6.50901 8.57615 6.88268C8.73093 7.25636 9.09557 7.5 9.50003 7.5H11V14C11 14.5523 11.4477 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload02SolidStandard);
export default __webpack_public_path__ + "static/media/upload-02-solid-standard.045cda206ebca09df47ad830da32d331.svg";
export { ForwardRef as ReactComponent };